import { Link, useIntl } from '@umijs/max';
import React from 'react';

/** 布局样式；颜色由 antd 全局 `colorLink*`（config/antdThemeByMode.ts）与 :hover 控制 */
const linkStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  fontSize: '.75rem',
  lineHeight: '1rem',
  textDecoration: 'none',
};

type MyGeneratedLinkProps = {
  assetTypeMessageId: string;
  to: string;
};

export const MyGeneratedLink: React.FC<MyGeneratedLinkProps> = ({
  assetTypeMessageId,
  to,
}) => {
  const intl = useIntl();

  return (
    <Link to={to} style={linkStyle}>
      {intl.formatMessage(
        { id: 'pages.home.myGenerated' },
        {
          type: intl.formatMessage({ id: assetTypeMessageId }),
        },
      )}
      <span aria-hidden style={{ lineHeight: 1 }}>
        →
      </span>
    </Link>
  );
};
